<template>
  <div class="my-files-container">
    <div class="left-sider-bar">
      <el-card class="user-info-container">
        <div class="user-info-box">
          <i class="el-icon-setting setting" @click="showSettingDialog" title="个人设置"></i>
          <img class="avatar" :src="userInfo.avatar" alt="">
          <p class="name">{{userInfo.realName+'（'+userInfo.dept+'）'}}</p>
          <p class="email">{{userInfo.email}}</p>
        </div>
      </el-card>
      <el-card class="function-menu-container" body-style="padding:0;">
        <div class="function-menu-item" :class="{'active':currentMenu==='default'}" @click="changeMenu('default')">
          <i class="el-icon-guide font"></i>
          默认
        </div>
        <!-- <div class="function-menu-item" :class="{'active':currentMenu==='allFiles'}" @click="changeMenu('allFiles')">
          <i class="el-icon-files font"></i>
          所有文件
        </div> -->
        <div class="function-menu-item" :class="{'active':currentMenu==='myCollection'}" @click="changeMenu('myCollection')">
          <i class="el-icon-star-off font"></i>
          我的收藏
        </div>
        <div class="function-menu-item" :class="{'active':currentMenu==='expiredFiles'}" @click="changeMenu('expiredFiles')" :title="countTitle">
          <i class="iconfont icon-yuqi-guoqi-06 font"></i>
          <el-badge :hidden="!count" :value="count" :max="99">
            <span class="badge-text">过期文件</span>
          </el-badge>
        </div>
      </el-card>
    </div>
    <!-- 对话框 -->
    <el-dialog :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :before-close="destroyComponent">
      <component :is="dialog.component" @close="destroyComponent" />
    </el-dialog>
    <MainEntrance :currentMenu="currentMenu" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MainEntrance from './mainEntrance.vue';
import MySetting from './components/mySetting.vue';
import { myFilesApi } from '@/api/index';
import { dialogMixin } from "@/common/mixins/";
export default {
  mixins: [dialogMixin],
  components: {
    MainEntrance,
  },
  computed: {
    ...mapGetters(['userInfo', 'mySetting'])
  },
  data () {
    return {
      currentMenu: '',
      count: 0,
      countTitle: '30天内，即将有0个文件过期！'
    }
  },
  watch: {
    mySetting (setting) {
      const { day } = setting;
      this.getSoonlyExpiredFilesCount(day);
    }
  },
  mounted () {
    this.currentMenu = localStorage.getItem('XPS_MY_FILES_MENU') || 'myCollection';
    if (this.mySetting) {
      const { day } = this.mySetting;
      this.getSoonlyExpiredFilesCount(day);
    }
  },
  methods: {
    showSettingDialog () {
      this.setDialog(true, '我的设置', MySetting, "800px", "15vh");
    },
    // 销毁动态组件
    destroyComponent () {
      this.setDialog(false, "", null, "800px", "15vh");
    },
    // 获取即将过期的文件
    async getSoonlyExpiredFilesCount (day) {
      const res = await myFilesApi.getSoonlyExpiredFilesCount({ day });
      if (res.code === 200) {
        this.count = res.data.count;
        this.countTitle = `${day || 30}天内，即将有${this.count}个文件过期！`
      }
    },
    // 改变菜单
    changeMenu (active) {
      localStorage.setItem('XPS_MY_FILES_MENU', active);
      this.currentMenu = active;
    }
  }
}
</script>

<style lang="scss" scoped>
.my-files-container {
  display: flex;
  padding: 24px;
  height: 100%;
  .left-sider-bar {
    min-width: 300px;
    width: 16%;
    .user-info-container {
      position: relative;
      margin-right: 20px;
      height: 200px;
      .user-info-box {
        text-align: center;
        .setting {
          position: absolute;
          top: 15px;
          right: 15px;
          font-size: 16px;
          color: #909399;
          cursor: pointer;
          &:hover {
            color: #409eff;
          }
        }
        .avatar {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
        .name {
          color: #606266;
          font-size: 16px;
          font-weight: 700;
        }
        .email {
          font-size: 14px;
          color: #adb4bf;
        }
      }
    }
    .function-menu-container {
      margin: 10px 20px 10px 0;
      padding-top: 20px;
      height: calc(100% - 210px);
      .function-menu-item {
        margin: 0px;
        padding: 20px 40px;
        color: rgb(157, 157, 168);
        font-weight: 500;
        line-height: 21px;
        cursor: pointer;
        .badge-text {
          padding-left: 5px;
          padding-right: 10px;
          vertical-align: text-bottom;
        }
        .font {
          margin-right: 2px;
          font-weight: 400;
        }
        &:hover {
          background-color: #fbfbfb;
        }
        &.active {
          font-weight: 600;
          color: #041677;
          background-color: #fbfbfb;
        }
      }
    }
  }
}
</style>